import { createIcons, Home, ChevronRight, ChevronDown, Building2, Award, Users, Star, Clock, Shield } from "lucide";

export default class AboutSidebar {
  constructor() {
    this.sidebar = document.querySelector(".js-about-sidebar");
    this.toggle  = document.querySelector(".js-about-sidebar-toggle");
    this.menu    = document.querySelector(".js-about-menu");
    if (!this.sidebar || !this.toggle || !this.menu) return;

    createIcons({
      icons: { Home, ChevronRight, ChevronDown, Building2, Award, Users, Star, Clock, Shield }
    });

    this.bind();
  }

  bind() {
    this.toggle.addEventListener("click", () => {
      const isOpen = this.menu.classList.toggle("open");
      this.toggle.classList.toggle("is-open", isOpen);
      this.toggle.setAttribute("aria-expanded", String(isOpen));
    });


    const MQ = 768;
    const onResize = () => {
      if (window.innerWidth >= MQ && this.menu.classList.contains("open")) {
        this.menu.classList.remove("open");
        this.toggle.classList.remove("is-open");
        this.toggle.setAttribute("aria-expanded", "false");
      }
    };
    window.addEventListener("resize", onResize);
  }
}
